import { render, staticRenderFns } from "./KoehlerPage.vue?vue&type=template&id=33875de0&"
import script from "./KoehlerPage.vue?vue&type=script&lang=js&"
export * from "./KoehlerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports